export enum General {
    GLOBAL = 'Global'
}
